import React, {useState} from 'react'
import Button from '../../ui/button'
import { LoaderIcon } from 'lucide-react';
import { isAuthenticated } from '../../api/api';

const SaveSettingButton = ({onSaveClick, addClass=''}) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
        
    const handleSaveClick = async () => {
        if (isAuthenticated()) {
            setIsProcessing(true);
            await onSaveClick();
            setIsProcessing(false);
            setIsSaved(true);
            setTimeout(() => {
                setIsSaved(false); // 1秒後に元の"Save Setting"に戻す
            }, 1000);
        }
    }

    const handleMouseEnter = () => {
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 1000); // 1秒後に自動で消す
    };
    
    return (
        <div className={`py-1 mx-4 relative ${addClass}`}>
            <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <div 
                    className={`rounded-full ${isAuthenticated() ? "bg-gray-500 hover:bg-gray-600" : "bg-gray-400 hover:bg-gray-400" } text-white focus:ring-2 focus:ring-offset-2 focus:outline-none flex cursor-pointer items-center justify-center px-4 text-sm md:text-md w-[55px] h-[25px] md:w-[55px] md:h-[30px]`}
                    aria-label="設定を保存"
                    onClick={handleSaveClick}
                    >
                    {isProcessing ? <LoaderIcon /> : isSaved ? "Saved" : "保存"}
                </div>
            </div>
            {showTooltip && 
                (
                    isAuthenticated() ?
                        <div className='absolute top-[35px] left-2 rounded-md text-white bg-gray-600 text-sm w-[130px] py-2 px-3 z-[9999]'>設定を保存する</div>
                    :
                        <div className='absolute top-[35px] left-2 rounded-md text-white bg-gray-600 text-sm w-[150px] py-2 px-3 z-[9999]'>ログインが必要です</div>
                )
            }
        </div>
    )
}

export default SaveSettingButton